import React from 'react'
import ReactDOM from 'react-dom/client'
import { WebApp } from './WebApp'
import { toast } from 'sonner'
import './index.css'
import './styles/safe-area.css'
import './styles/blocknote.css'

// Register Service Worker for PWA (production only)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    let hasShownUpdateToast = false
    let isRefreshing = false

    const reloadOnce = () => {
      if (isRefreshing) return
      isRefreshing = true
      window.location.reload()
    }

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      reloadOnce()
    })

    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('[SW] Service Worker registered:', registration.scope)

        const showUpdateToast = () => {
          if (hasShownUpdateToast) return
          hasShownUpdateToast = true

          toast('Ny version av Brian 2 finns tillgänglig.', {
            id: 'pwa-update-available',
            duration: Infinity,
            action: {
              label: 'Uppdatera nu',
              onClick: () => {
                const waitingWorker = registration.waiting
                if (waitingWorker) {
                  waitingWorker.postMessage({ type: 'SKIP_WAITING' })
                } else {
                  reloadOnce()
                }
              }
            },
            cancel: {
              label: 'Senare',
              onClick: () => {
                hasShownUpdateToast = false
              }
            },
            onDismiss: () => {
              hasShownUpdateToast = false
            }
          })
        }

        const watchInstallingWorker = (worker: ServiceWorker | null) => {
          if (!worker) return
          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[SW] New version available! Show update toast.')
              showUpdateToast()
            }
          })
        }

        watchInstallingWorker(registration.installing)

        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          watchInstallingWorker(newWorker)
        })
      })
      .catch(error => {
        console.error('[SW] Service Worker registration failed:', error)
      })
  })
}

// In dev, unregister any existing service workers to avoid stale bundles / invalid hook call
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(reg => {
      reg.unregister().catch(() => null)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WebApp />
  </React.StrictMode>,
)
